import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const orderSummary = {
  id: 'order-summary',

  getDocumentRequestNotificationProps: (docCount, selectedPrinterName) => ({
    title: <FormattedMessage {...messages.printingOrderSummaryTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.sentToPrinter} values={{ selectedPrinterName }} />,
  }),
};
